var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ( _vm.orderError != null )?_c('div',{staticClass:"order-error"},[_c('font-awesome-icon',{staticStyle:{"font-size":"30px"},attrs:{"icon":"exclamation-triangle"}}),_c('p',[_vm._v("\n\n        "+_vm._s(_vm.orderError)+"\n    ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }